export default {
    sysTitle: "Charging pile background management system",
    sysMenu: "System",
    currentPosition: "current position",
    operatorId: "Operator code",
    oprName: "Name of operator",
    oprPkId: "Operator ID",
    tips: "Tips",
    isDelete: "Are You Sure You Want to Delete",
    deleteSuccess: "Successfully Deleted",
    updateSuccess: "Successfully Update",
    addSuccess: "Add Successfully",
    all: "All",
    operation: "Operation",
    dl: "quantity of electricity",
    eleFee: "Electricity fees",
    serverFee: "Service fees",
    delayFee: "Delay fee",
    totalAmount: "Total amount",
    yuan: "yuan",
    kWh: "kWh",
    unitOrder: "single",
    ac: "AC",
    dc: "DC",
    confirm: "confirm",
    noData: "No data",
    allCity: "All cities",
    chargingStation: "Charging station",
    merchant: "Merchant",
    operator: "Operator",
    chargingPile: "Charging pile",
    year: "Year",
    month: "Month",
    day: "Day",
    timeType: "Time type",
    regularText: "Regular",
    irregular: "Irregular",
    disabled: "disabled",
    operationSucess: "operation Sucess",
    saveSucess: "Successfully Save",
    exportSuccess: "Import succeeded",
    allSelect: "All Select",
    toExamine: "To examine",
    invalid: "Invalid",
    remark: "remark",
    nothing: "nothing",
    preservation: "Preservation",
    recharge: "Recharge",
    determine: "Determine",
    //单位
    unitText: {
        pen: "pen",
        yuan: "yuan",
        hours: "hours",
        people: "people",
        seat: "seat",
        wyuan: "w yuan",
        wkWh: "w kWh",
        wkW: "w kW",
        year: "year",
        month: "month",
        day: "day",
        ton: "ton",
        second: "second",
        full: "full",
        reduce: "reduce",
        give: "give",
        zhang: "zhang",
        individual: "individual",
        minute: "minute",
        seconds: "second",
    },
    formText: {
        startTime: "startTime",
        endTime: "endTime",
        export: "export",
        exportLoading: "loading...",
        exportNumber: "Number of exports",
        exportPl: "The number of exports cannot be less than or equal to 0",
        exportError: "Export error or timeout",
        allCity: "all city",
        selectGun: "Charging gun",
        selectMch: "Merchant",
        selectSite: "Charging station",
        selectPile: "Charging pile",
        selectTime: "Choose the time",
        selectTimePl: "Please select the time",
        selectOper: "Operators",
        downloadForm: "Download form",
        intTips: "number",
        beginTimeTips: "Please select start time",
        endTimeTips: "Please select end time",
        import: "Import",
        selectProvince: "Please select Province",
        selectCity: "Please select a city",
        selectArea: "Please select area",
        subSuccess: "Operation successful",
        goBack: "Go back",
        timeNull: "Please select a time",
        timeMax: "The start time cannot exceed the end time",
        time24: "24 hours",
        time7: "7 days",
        time30: "30 days",
        timeCustom: "custom",
        uploadError: "Please upload the following file types:",
        copySuccess: "Copy successfully",
        loginTimeOut: "Login expired, please log in again",
        selectPl: "Please select",
    },
    directCurrent: "DC",
    alternatingCurrent: "AC",
    gunStatus: "gun status",
    gunStatusObj: {
        onLine: "on line",
        offLine: "off line",
        free: "free",
        connected: "connected",
        charging: "charging",
        full: "full",
        trouble: "trouble",
        disabled: "disabled",
        booked: "booked",
    },
    //===========================按钮===========================
    search: "search",
    updata: "edit",
    update: "edit",
    add: "add",
    edit: "edit",
    delete: "delete",
    allDel: "batch deletion",
    close: "Close",
    save: "Save",
    refresh: "Refresh",
    back: "go back",
    export: "export",
    import: "import",
    submit: "submit",
    cancel: "cancel",
    details: "details",
    browse: "browse",
    //===========================按钮===========================
    // 验证
    regular: {
        name: "name",
        please: "Please input",
        pleaseSelect: "Please select",
        max: "No more than",
        maxText: "characters",
        min: "Not less than",
        numberABC: "It can only consist of numbers or letters",
        numberABCs: "It can only be composed of numbers, letters and underscores",
        tel: "Please enter the mobile number or the phone number, 7-15 digits",
        phone: "Please enter the phone number",
        phonePl: "Please input mobile phone number",
        phonePl11: "Please enter the 11 digit mobile phone number",
        phoneError: "Please input the correct mobile phone number",
        int: "It can only be an integer number",
        maxInput: "Maximum input",
        minInput: "Minimum input",
        unit: "",
        maxNum: "Cannot be greater than",
        minNum: "Cannot be less than",
        money: "amount of money",
        towDecimal: "Keep up to two decimal places",
        email: "Please input email",
        emailPl: "Mailbox cannot exceed",
        emailError: "Please fill in the correct email",
        passwordPl: "Please input a password",
        passwordError: "The password must contain letters and numbers and be between 8 and 16 in length. Please re-enter",
    },
    // 登录
    login: {
        loginTitle: "Charging pile background management system",
        userName: "user name",
        password: "password",
        loginBtn: "Sign in",
        userNamePl: "enter one user name",
        passwordPl: "Please input a password",
        passwordError: "Please enter a password with more than 6 digits",
    },
    //权限配置
    role: {
        roleList: "Role list",
        autoMenu: "Menu",
        autoConfig: "Configure permissions",
        roleName: "Role name",
        roleType: "Role type",
        roleDesc: "remarks",
        createUserName: "creater",
        createTime: "Creation time",
        modifyTime: "Update time",
        addRole: "Add role",
        upRole: "Modify role",
        roleTypePl: "Please select role type",
        moduleName: "Menu module",
        checkRender: "Permission list",
        operationUserName: "operator",
        operationTime: "operation time",
        operationIp: "operation IP",
        operationTypeName: "Operation type",
        content: "Operation content",
        lastOperationUserName: "Last operator",
        lastOperationTime: "Last operation time",
        lastOperationIp: "Last operation IP",
        log: "Operation details",
    },
    // 用户管理
    user: {
        globalSearch: "Enter keyword search (user name / role / creator)",
        system: "system",
        resetPassword: "reset password",
        userName: "user name",
        fullName: "full name",
        phone: "phone",
        objectName: "Operator",
        delUserConfirm: "Are you sure to delete the selected user?",
        addUser: "Add users",
        upUser: "Modify user",
        info: "essential information",
        userPwd: "password",
        confirmPassword: "Confirm password",
        userPwdNull: "Please input a password",
        userPwdMin: "Password length is 18 ~ 6 characters",
        userPwdError: "The password cannot contain spaces, tabs, or line breaks",
        userPwdTowError: "Please confirm whether the old and new passwords are consistent",
        queryUser: "View user",
        userRolePl: "Please select a role",
        newPassword: "New password",
    },
    //日志
    log: {
        tab1: "Operation log",
        tab2: "Login log",
        loginIp: "Login IP",
        loginTime: "login time",
        resultDesc: "Operation details",
        logGlobalSearch: "Enter keyword search (user name, login IP)",
        operationLogGlobalSearch: "Enter keyword search (user name / module name / operation method / client IP)",
        requestIp: "Customer IP",
        moduleName: "Module name",
        methodDesc: "Operation method",
        operatorTime: "Operation time",
        responseCode: "Operation details",
    },
    // 在线用户
    onlineuser: {
        globalSearch: "Please enter keywords (username / login / IP address)",
        offline: "Forced offline",
        offlineConfirm: "Are you sure you want to force logoff?",
        userFullName: "Role name",
        ipAddress: "IP address",
        loginTime: "login time",
    },
    // 典表
    dictionary: {
        globalSearch: "Enter keyword search (dictionary name)",
        add: "Addendum items",
        updata: "Modify items",
        items: "items",
        child: "Children",
        read: "read-only",
        addOp: "All operations",
        edit: "edit",
        typeName: "Dictionary name",
        typePkId: "Key value",
        itemList: "Canonical table item",
        typeFlag: "Canonical entry status",
        typeFlagPl: "Please select the table item status",
        remark: "remark",
        modifyTime: "Update time",
        // 子页面
        itemsManage: "items manage",
        childGlobalSearch: "Enter keyword search(items name)",
        rise: "rise",
        decline: "decline",
        itemValue: "items name",
        englishName: "items english name",
        itemKey: "key",
        itemKeyPl: "Please select key",
        flag: "state",
        normal: "normal",
        disable: "disable",
    },
    // 系统升级
    systemNotice: {
        add: "Add system upgrade",
        upgradeContent: "System upgrade content",
        upgradeTime: "System upgrade time",
        version: "version",
        versionPl: "Please enter the version number",
        upgradeContentPl: "Please enter the system upgrade content",
        upgradeTimePl: "Please select the system upgrade time",
        updata: "Modify system upgrade",
    },
    // 模板文件
    modelFile: {
        add: "Add template file",
        templateFile: "template file",
        fileName: "file name",
        pkid: "File primary key",
        createUserId: "Founder",
        createTime: "Creation time",
        attachmentPkId: "Attachment primary key",
        modifyUserId: "Modifier",
        modifyTime: "Modification time",
        businessType: "Business type",
        fileType: "file type",
        templatePkId: "File template primary key",
        attachmentPkIdPl: "Please upload the template file",
        businessTypePl: "Please enter the business type",
        fileNamePl: "Please enter a file name",
        fileTypePl: "Please select a file type",
        remarkPl: "Please enter comments",
        updata: "Modify template file",
        lang: "language",
        langPl: "Please select language",
    },
    // 菜单
    menuList: {
        roleType: "system",
        child: "children",
        moduleName: "Menu name",
        englishName: "Menu English name",
        privilegeVoList: "privilege",
        icon: "icon",
        sort: "sort",
        url: "link",
        moduleNamePl: "Please enter a name",
        englishNamePl: "Please enter your English name",
        urlPl: "Please enter a link",
        addChild: "Add submenu",
        updata: "Modify submenu",
        add: "Add menu",
        auto: "privilege select",
        addAuto: "Add privilege",
        privilegePl: "Please select privilege",
    },
    //停止原因
    stopReason: {
        allConfig: "Batch setting",
        add: "Add stop reason",
        stopCode: "Stop code",
        stopName: "Stop reason",
        duty: "Responsibility distribution",
        addRow: "Add a row",
        updata: "Modify stop reason",
        stopCodePl: "Please enter the stop code",
        stopNamePl: "Please enter a stop name",
        responsibilityTypePl: "Please select a responsibility assignment",
        configDataPl: "Please select the data to configure",
        configSuccess: "Configuration successfully",
        responsibilityType: "Responsibility distribution",
    },
    // 告警配置
    alarmSet: {
        allConfig: "Batch setting",
        add: "Added alarm configuration",
        updata: "Modify the alarm configuration",
        alarmLevel: "Alarm level",
        alarmType: "Alert Type",
        faultName: "fault name",
        faultCode: "error code",
        faultTipMsg: "User prompt information",
        type: "Alert Type",
        addRow: "add a line",
        faultCodePl: "Please enter the fault code",
        faultTipMsgPl: "Please enter user prompt information",
        alarmLevelPl: "Please select an alarm level",
        alarmTypePl: "Please select an alert type",
        configDataPl: "Please select the data to configure",
        configSuccess: "Configuration successfully",
        solution: "Solution",
        solutionPl: "Please enter a solution",
        faultNamePl: "Please enter a fault name",
        faultEnName: "fault English name",
        faultEnNamePl: "Please enter English name",
        faultTipEnMsg: "English name prompt",
        faultTipEnMsgPl: "Please enter user prompt information in English",
    },
    // kafka 日志
    kafkaLog: {
        globalSearch: "Enter keyword search (topic)",
        partition: "partition",
        createTime: "creation time",
        startOffset: "offset min",
        endOffset: "offset max",
        consumption: "consumption",
        allConsumption: "Bulk re-consumption",
        allConsumptionConfirm: "Are you sure you want to re-consume the selected one??",
        allDel: "batch deletion",
        allDelConfirm: "Are you sure you want to delete the selected one?",
        topic: "topic",
        topicInfo: "Consuming topic information",
        requestParam: "request parameter",
        reason: "error message",
    },
    // 订单校验配置
    orderConfig: {
        allOpen: "batch open",
        allOpenConfirm: "Are you sure you want to batch open the selected ones?",
        allClose: "batch close",
        allCloseConfirm: "Are you sure you want to close the selected ones in bulk?",
        open: "activated",
        close: "closed",
        enabled: "Whether to enable verification",
        faultName: "wrong name",
        faultCode: "error code",
        faultDesc: "Error brief",
        faultTypeDesc: "Error type description",
    },
    // 告警配置
    alarmsetting: {
        tab1: "Device Alarm Batch Settings",
        tab2: "Device alarm settings one by one",
        tab3: "SIM traffic alert settings",
        set: "set up",
        alarmLevel: "Alarm level",
        faultCode: "error code",
        faultName: "Fault description",
        flow: "Flow threshold",
        setLevel: "Set the alarm level",
        alarmLevelName: "Alarm level",
    },
    // 费率管理
    ratamanage: {
        tab1: "System Rate Template",
        tab2: "Carrier Rate Template",
        templateName: "template name",
        updateTime: "update time",
        jian: "sharp",
        feng: "peak",
        ping: "flat",
        gu: "valley",
        acRate: "AC pile charging rate",
        dcRate: "DC pile charging rate",
        delayRate: "Delay fee rate",
        bindStaNum: "usage amount",
        modifyTime: "creation time",
        rateDetails: "rate details",
        delayRateDetails: "Delay Fee Rate Details",
        slotDelayPrice: "Rate (yuan/minute)",
        ent: "enterprise",
        bindSta: "Affiliate site",
        stationName: "Site name",
        stationAddress: "site address",
        index: "serial number",
    },
    //新增费率
    addRatamanage: {
        feeName: "template name",
        rate: "charging rate",
        delayFreeMinutes: "Free time (minutes)",
        add: "Add system rate template",
        addOper: "Added carrier rate template",
        feeNamePl: "Please enter a template name",
        acRate: "AC Pile Rate",
        dcRate: "DC Pile Rate",
        delayRate: "Delay fee rate",
        slotFlag: "electricity price type",
        slotElecPrice: "electricity price(yuan)",
        slotServicePrice: "service charge(yuan/kWh)",
        timeValue: "period",
        pricePl: "Please enter a number for the price",
        priceMax: "The current price cannot exceed",
        selectTimePl: "Please select a time to add",
        timeNoSelect: "All 24 hours have been selected and cannot be added",
        timeError: "Time periods overlap, please check",
        timeNoSelectSuccess: "Please select the full 24 hours",
        slotElecPriceMax: "The price of electricity cannot exceed",
        slotServicePriceMax: "The service fee price cannot exceed",
        please: "please enter",
        slotDelayPrice: "Rate (yuan/minute)",
    },
    // 设备型号
    equipmentModel: {
        deviceType: "Equipment type",
        updateTime: "update time",
        globalSearch: "Device model/manufacturer",
        deviceModelName: "Device model",
        standard: "Standard information",
        matching: "Optional information",
        manufacturerName: "manufacturer",
        delDeviceModelName: "Are you sure you want to delete the selected device model?",
        minSelectItem: "Please select at least one item",
        factoryInfo: "Manufacturer information",
        manufacturerPkId: "manufacturer's name",
        matchingAdd: "Optional additions",
        optionName: "option name",
        remark: "Option Description",
        addDeviceModel: "Add device model",
        deviceModelNamePl: "Please enter the device model",
        manufacturerPkIdPl: "Please select manufacturer name",
        optionNamePl: "Please enter an option name",
        isChecked: "Is it standard",
        optionValue: "Fixed value",
        deviceModelDetails: "Device Model Details",
        updataDeviceModel: "Modify device model",
        optionValueError: "The fixed value of the selected standard item cannot be empty",
        deviceTypeInfo: "Model information",
        deviceTypePl: "Please select device type",
        deviceModelPkIdPl: "Please select device model",
        optionEnName: "English name",
        optionEnNamePl: "Please enter English name",
        remarkEn: "English option description",
        remarkEnPl: "Please enter an English option description",
    },
    // 新增设备型号
    addEquipmentModel: {
        typeInfo: "Model information",
        deviceType: "Equipment type",
        deviceModelName: "Equipment model",
        name1: "Standard configuration",
        name2: "Optional",
        manufacturerInfo: "Manufacturer information",
        optionalAdd: "Optional new items",
        manufacturerPkId: "Name of manufacturer",
        optionName: "Option name",
        remark: "Option description",
        addDevType: "Add device model",
        deviceModelNamePl: "Please enter the device model",
        manufacturerPkIdPl: "Please select manufacturer name",
        optionNamePl: "Please enter an option name",
        isChecked: "Is it standard",
        optionValue: "Fixed value",
        valueNull: "Value cannot be empty",
        valueError: "The value can only be positive",
        detailsTitle: "Equipment model details",
        upTitle: "Modify equipment model",
        addTitle: "New equipment model",
        addSplitPile: "Add split device model",
        delDevType: "Delete device model",
        outPutRange: "Output range",
    },
    // 设备清单
    equipmentList: {
        sns: "Device SN",
        snsPl: "sn, multiple separated by commas",
        allSns: "batch",
        isBindOper: "Attachment status",
        projectName: "Attribution project",
        maintenanceMethodsType: "Maintenance method",
        export: "import device",
        add: "Add device",
        relation: "relation",
        disassociate: "disassociate",
        disassociateConfrim: "Are you sure you want to unlink the selected device?",
        delConfirm: "Are you sure you want to delete the selected device?",
        unattached: "unattached",
        attached: "attached",
        serialNumber: "Device SN",
        gunNum: "muzzle count",
        belongInfo: "Attachment information",
        //导入
        import: "Select import file",
        importTpl: "import template",
        importTplDownload: "Import template download",
        total: "Total this time",
        dev: "device",
        dc: "Dc",
        ac: "Ac",
        protocolPkId: "protocol",
        protocolPkIdPl: "Please select an agreement",
        //详情
        detailsTitle: "Device Details",
        dataDetails: "Parameter details",
        manufacturerName: "Manufacturer",
        // 关联
        typeNumber: "Model number of devices",
        changeModel: "change model",
        bindDev: "Associated devices",
        unBindDev: "Device to be associated",
        changeOper: "change carrier",
        noChangeOper: "Equipment to be replaced",
        bindOper: "Affiliated operator",
        operPl: "Please select an operator",
        deviceModelPl: "Please select a device",
        //新增
        addSn: "Equipment SN interval",
        quantity: "quantity",
        addBtn: "Add",
        snNull: "Device SN cannot be empty",
        snInt: "Device SN must be a number",
        pileCommissioningDate: "Operation time",
        pileCommissioningDatePl: "Please select the commissioning time",
        pileProductionDate: "productive time",
        pileProductionDatePl: "Please select the production time",
    },
    // 设备厂商
    producer: {
        busLicenseNumber: "Business license number",
        brandName: "brand name",
        manufacturerName: "equipment manufacturer",
        manufacturerId: "Equipment Manufacturer Organization Code",
        contactName: "contact",
        phoneNo: "phone",
        legalPerson: "Corporate",
        legalIdCard: "Legal person ID",
        busLicenseNumberPl: "Please enter the business license number",
        busLicenseNumberMax: "The length of the business license number is 18 digits",
        brandNamePl: "Please enter a brand name",
        manufacturerNamePl: "Please enter device manufacturer",
        manufacturerIdPl: "Please enter the device manufacturer organization code",
        manufacturerIdMax: "The length of the business license number is nine digits",
        legalPersonPl: "Please enter company legal person",
        legalIdCardPl: "Please enter legal person ID",
        legalIdCardMax: "The length of the legal person ID card is 18 characters",
        contactNamePl: "Please enter a contact",
        add: "Add equipment manufacturers",
        updata: "Modify device manufacturer",
    },
    // 运营商
    oper: {
        operData: "Number of operators",
        operTotal: "Total number of operators",
        accData: "Account Expiration Analysis",
        globalSearch: "Enter keyword search (operator name/operator abbreviation)",
        oprStatus: "Operational status",
        expireDays: "Date of Expiry",
        customMade: "custom made",
        msgConfig: "SMS config",
        phoneConfig: "Mobile config",
        day30: "30 days due",
        day60: "60 days due",
        day90: "90 days due",
        companyName: "short name",
        userName: "admin",
        deviceCount: "Equipment Quantity",
        createTime: "create time",
        delOper: "Are you sure you want to delete the carrier?",
        expireTime: "Expire date",
        //短信配置
        msgServer: "SMS service",
        agent: "SMS service provider",
        pilot: "pilot",
        operMsg: "operator owned",
        signName: "SMS signature",
        "201": "Charging start notification",
        "202": "Charging end notification",
        "203": "Charge settlement notice",
        "301": "Failure notification",
        "204": "Insufficient balance reminder",
        "205": "Send coupon template",
        "101": "Login SMS Template",
        "104": "Authentication Template",
        "102": "Modify password template",
        "103": "Information Change Template",
        "105": "Coupon template",
        agentPl: "Please select an agent",
        signNamePl: "Please enter a signature",
        please: "please enter",
        //新增运营商
        addOper: "Carrier basic information",
        operatorId: "Organization Code",
        operMax: "Please enter no more than 30 characters",
        companyNameMax: "within 10 characters",
        address: "Address",
        addressPl: "Please enter detailed address",
        addressPlCity: "Please choose the city",
        description: "company description",
        contactPerson: "contact",
        tel: "contact number",
        serviceTel: "consumer hotline",
        contactsMail: "Contact email",
        oprSystemName: "Carrier System Name",
        oprSystemLogoFilePath: "System LOGO",
        operTime: "Operation period",
        activeTime: "effective time",
        allTime: "permanent",
        add: "Add operator",
        updata: "updata operator",
        query: "View operator",
        rolePkIdPl: "Please select an operator role",
        oprSystemLogoFilePathPl: "Please upload the operator system logo",
        qrCodeFilePathPl: "Please upload the QR code",
        mchCertFilePathPl: "Please upload a request for a refund certificate",
        logoPl: "please upload logo",
        activeTimePl: "Please select the effective time",
        zfbNamePl: "Please enter SMS signature",
        // 定制
        customTitle: "custom function",
        gunQrCodeType: "QR code link of charging pile muzzle",
        gunQrCodeTypePl: "Please choose the type",
        gunQrCodeType1: "Interconnection",
        gunQrCodeType2: "Public account link method",
        gunQrCodeTypeTextP1: "1. After the operator creates it, configure the custom function separately",
        gunQrCodeTypeTextP2: "2. The default interconnection mode of the muzzle QR code, that is, the current QR code mode",
        gunQrCodeTypeTextP3: "3. The link method of the official account is to scan the QR code of the muzzle with the link mode of the official account",
        accTime: "Account Expiration Analysis",
        loginInfo: "Carrier login information",
        loginUrl: "login information",
        loginName: "Login account",
        loginPasswd: "login password",
        tips: "Note: Please save your login information, if you forget your password, please click reset;",
        resetPassword: "reset Password",
        close: "close",
        copy: "Quick copy",
        loginPassword: "login password",
        //分成配置
        settlementTitle: "Sharing rules",
        settlementType: "Classification Rule Type",
        maxSettlementRatio: "Maximum order sharing",
        settlementConfigTitle: "Divider",
        shareName: "Name of dividing party",
        merchantName: "Name of receiving merchant",
        merchantPkId: "Collection merchant account",
        ruleType: "Divided into types",
        ruleTypeSelect2: "percentage",
        ruleTypeSelect1: "Quota sharing",
        base: "Each order",
        baseDl: "Divided by kWh",
        totalAmount: "Total amount",
        serviceCharge: "service charge",
        settlementTypePl: "Please select the classification rule type",
        maxSettlementRatioName: "Share ratio",
        amountTypePl: "Please select the amount type",
        baseName: "Divided value",
        ruleTypePl: "Please select the type of division",
        removeConfirm: "Are you sure you want to delete this party?",
        splitConfig: "Split config",
        stop: "stop",
        start: "Enable",
        stopConfirm: "Are you sure you want to shut down the operator?",
        startConfirm: "Are you sure you want to enable the operator?",
        applicationStatus: "Special merchant application status",
        oprRegisterType: "Registration method",
        hasOpenCreditAuthority: "Charge first, pay later",
        hasOpenCreditAuthorityPl: "Please choose whether to turn it on or not",
        open: "open",
        customerCode: "Customer code",
        customerCodePl: "Please enter an 8-digit customer code",
    },
    // 运营商公众号
    operWeChat: {
        title: "WeChat configuration",
        hasWeChat: "Whether to open",
        yes: "Yes",
        notifyUrl: "Pay for a domain name",
        authorizeUrl: "Authorized Domain Name",
        menuLink: "menu link",
        wxInfo: "WeChat information",
        weChatLogo: "logo",
        qrCodeFilePath: "QR code",
        weChatName: "weChat name",
        primevalId: "original ID",
        appId: "appId",
        appSecret: "secret",
        wxMchInfo: "business information",
        mchName: "Business Name",
        mchId: "Merchant ID",
        mchKey: "Merchant Key",
        mchCertFilePath: "Request a Refund Certificate",
        download: "Download certificate",
        mchCertName: "Payment certificate name",
        mchCert: "Payment certificate path",
        mchCertPwd: "Merchant certificate password",
        mchPosid: "Counter code",
        mchBranchid: "Branch code",
        mchTxCode: "Transaction code",
        mchUserId: "operator number",
        mchPassword: "operator password",
        ipAddr: "Outreach platform ip",
        port: "External port",
        wxPayPointsTitle: "WeChat Pay points",
        mchCertSerialNo: "Serial Number",
        mchCertPrivateKey: "Merchant Certificate Private Key",
        serviceIntroduction: "service information",
        mchV3Key: "Merchant V3 Key",
        serviceId: "WeChat Pay sub service id",
        required: "Required",
        appName: "apply name",
        infoTitle: "Basic information",
        version: "version",
        xlType: "Payment version",
        mchType: "Merchant type",
        mchTypePl: "Please select merchant type",
        oprAuditStatus: "Audit status",
        AppID: "App ID",
        mchPrivatePassword: "Merchant private key password",
        mchPrivateKey: "Merchant private key",
        mchPrivateKeyPl: "Please upload the account private key",
        entPublicKey: "Enterprise Gateway Public Key",
        entPublicKeyPl: "Please upload the enterprise gateway public key",
        isSupportLedgerSplit: "Does it support ledger splitting",
        isSupportLedgerSplitPl: "Please select whether to support split accounting",
        zfbInfo: "Alipay payment information",
        mchNo: "Merchant No",
    },
    // 小程序
    operWeChatApp: {
        title: "WeChat applet configuration information",
        hasWeChat: "Whether to open",
        weChatLogoFilePath: "logo",
        qrCodeFilePath: "QR code",
        weChatName: "applet name",
        primevalId: "business information ID",
        wxMchInfo: "Wechat applet merchant information",
        wxInfo: "WeChat applet information entry",
    },
    //支持宝小程序
    operPay: {
        title: "Alipay applet configuration information",
        hasZfbMini: "Open the Alipay applet",
        logo: "logo",
        qrCode: "QR code",
        zfbName: "Application Name",
        privateKey: "Apply private key",
        alipayPublicKey: "Alipay public key",
    },
    //运营商账号
    operAccount: {
        reconciliation: "Manual reconciliation",
        abnormalSum: "number of exceptions",
        result: "reconciliation result",
        accDetails: "Account Details",
        details: "Reconciliation Details",
        formula: "Compare accounts",
        abnormalReason: "Comparison details",
        leftAmount: "money on the left",
        rightAmount: "money on the right",
        money: "difference",
        accountType: "account type",
        accountPkId: "account number",
        balanceAmount: "balance",
        orderNo: "Charging order number",
        orderNoPl: "Please enter charging order number",
        userCorrectAmount: "Personal user account offset amount",
        userCorrectAmountPl: "Please enter the personal user account offset amount",
        prepayCorrectAmount: "Escrow account offset amount",
        prepayCorrectAmountPl: "Please enter the escrow account offset amount",
        chargeCorrectAmount: "Charge account offset amount",
        chargeCorrectAmountPl: "Please enter the charging account offset amount",
        password: "Operation password",
        passwordPl: "Please enter the operation password",
    },
    // 发布通知
    postNotice: {
        globalSearch: "Title fuzzy search",
        publish: "publish",
        publishConfirm: "Are you sure you want to publish?",
        withdraw: "withdraw",
        withdrawConfirm: "Are you sure you want to withdraw?",
        title: "title",
        titlePl: "Please enter a title",
        content: "content",
        contentPl: "Please enter content",
        createTime: "creation time",
        publishTime: "release time",
        publishStatus: "Post status",
        email: "E-mail notification",
        emailPl: "Please select email notification",
        open: "open",
        close: "close",
        add: "Add publish",
        operPl: "Please select an operator",
        details: "publish details",
        updata: "Updata publish",
    },
    // 余额提醒
    balanceReminderPage: {
        triggerValue: "Balance reminder",
        triggerValueTips: "Account balance below",
        triggerValueTips2: "Yuan, send the notification.",
        sendWays: "Notification method",
        sendWaysTips: "Official account notification",
        triggerVTips2: "SMS notification",
        wxTpl: "Official account template detection",
        msgTpl: "SMS template detection",
        configured: "Configured",
        noConfigured: "not configured",
        noTips: "No SMS template detected, please contact the platform service provider for configuration",
        wxMessage: "Official account notification",
        msgMessage: "SMS notification personnel",
        phoneTips: "Enter the mobile phone number, and separate the numbers with",
        sendWaysPl: "Please select notification method",
        phonePl: "Please enter the number",
        phoneError: "Wrong number format, separated by ','",
        phoneMax: "The number cannot exceed 5 groups",
    },
    // 互联互通
    auditHlhtSystem: {
        systemnName: "Systemn Name",
        netDriection: "Interconnection direction",
        netStatus: "Approval Status",
        globalSearch: "keywords",
        netFileName: "Download attachments",
        audit: "audit",
        auditModal: "Audit interconnection",
        yes: "pass",
        no: "Fail",
        systemName: "system name",
        reason: "Reason for Application",
        netType: "Interworking type",
        beginTime: "Start time",
        endTime: "End Time",
        contactName: "contact",
        phoneNo: "phone",
        netPublic: "Public type",
        hasOpen: "On state",
        oprSum: "Operator has been activated",
        netSystemSum: "Interconnection and interworking",
        netSystemSum2: "Interworking direction",
        netSystemSum3: "Interworking Public type",
        netSystemSum4: "On state",
        netForwardSum: "Forward direction",
        netReverseSum: "Opposite direction",
        netBidirectionalSum: "Two-way",
        netInsideSum: "Interior",
        netExternalSum: "Outside",
        netNoSum: "Open",
        netOffSum: "Close",
        netEndSum: "Ending Count",
        accountBalance: "Account balance",
        status: "Status",
        balanceReminder: "Balance reminder",
        siteOpen: "Site Open Management",
        refund: "refund",
        rapitalRecords: "Fund records",
        accountStatement: "statement of account",
        pullSite: "Pull Site",
    },
    // 互联互通
    interflowListSend: {
        operatorId: "Organization structure code",
        projectName: "entry name",
        systemName: "System name",
        protocolPkId: "Protocol primary key",
        phoneNo: "contact information",
        contactName: "contacts",
        netDriection: "Interworking direction",
        netType: "Interworking type",
        beginTime: "Internet start date",
        endTime: "Interconnection end date",
        netFileUrl: "enclosure",
        upload: "Upload file",
        reason: "Reasons for application",
        tab1: "essential information",
        tab2: "Platform key",
        tab3: "Carrier key",
        addInterflow: "New interconnection",
        reasonPl: "Please input the reason for application",
        netDriectionPl: "Please choose the direction of interchange",
        netTypePl: "Please select interworking type",
        beginTimePl: "Please select start time",
        endTimePl: "Please select the end time",
        netFileUrlPl: "Please upload the attachment",
        protocolPkIdPl: "Please enter agreement primary key",
        upInterflow: "Modification of interconnection",
        detailsInterflow: "Interconnection details",
        aesDataSecret: "Data encryption key",
        aesDataSecretIV: "Initialization vector",
        operatorSecret: "Carrier key",
        sigSecret: "Signature key",
        requestUrl: "Request platform address",
        rechargeAmount: "Recharge amount (yuan)",
        rechargeSuccess: "Recharge success",
        refundAmount: "Refund amount (yuan)",
        refundBtn: "refund",
        refundError: "The refund amount cannot exceed the account balance",
        refundSuccess: "Refund successful",
        refundOrderNo: "order number",
        balance: "Account balance",
    },
    // 互联互通-- 资金记录
    interflowRecord: {
        tab1: "Charge",
        tab2: "Recharge",
        tab3: "Refund",
        accountPkId: "Account number",
        modelTitle: "Fund records",
    },
    // 互联互通-- 对账单
    interflowBill: {
        abnormal: "Push results",
        queryDetails: "detailed",
        errorOrder: "Abnormal order",
        normal: "normal",
        error: "abnormal",
        beginTime: "Billing start time",
        endTime: "Billing end time",
        orderNumber: "Number of orders",
        totalChargeElect: "Total electricity (KWH)",
        totalAmount: "Total amount (yuan)",
        abnormalNumber: "Number of abnormal orders",
        abnormalAmount: "Abnormal order amount (yuan)",
        checkingResult: "Check the results",
        reset: "reset",
        diffContent: "Reasons for dispute",
        tab1: "Account Statement",
        tab2: "Statement details",
    },
    //增值服务
    addValueService: {
        serviceName: "service name",
        logo: "service logo",
        hasOpen: "open state",
        add: "Add value-added services",
        enable: "enable",
        disabled: "disabled",
        logoPl: "Please upload file",
        hasOpenPl: "Please select a status",
    },
    //参数配置
    dataConfig: {
        tab1: "Electricity bill configuration",
        tab2: "QR code configuration",
        connectLoading: "connecting.....",
        connectClose: "The connection was interrupted or the connection was closed",
        reconnect: "reconnect",
        realTimeMsg: "real-time message",
        clear: "clear",
        gunPkIdPl: "Please select a muzzle",
        subscribeSuccess: "Subscription succeeded",
        pilePkId: "pile number",
        pilePkIdPl: "Please select pile",
        gunPkId: "gun number",
        ratedVoltage: "Rated voltage",
        ratedCurrent: "Rated current",
        ratedPower: "equipment power",
        // 报文
        reply: "reply",
        get: "get",
        pile: "pile",
        platform: "platform",
        pileData: "pile data",
        platformData: "Platform data",
        // 二维码
        rateName: "QR code",
        rateNamePl: "Please enter the QR code string",
        getBtn: "recall test",
        issue: "Issue QR code",
        send: "send",
        clickSend: "Click to send",
        response: "response",
        issueSuccess: "issued successfully",
        //电费配置
        ratePkid: "rate",
        rateTpl: "Rate Template Name",
        acRate: "AC Pile Rate",
        pileRate: "pile rate",
        platformRate: "Platform rate",
        slotFlag: "price type",
        slotElecPrice: "electricity price(yuan/kWh)",
        slotServicePrice: "service charge(yuan/kWh)",
        time: "period",
    },
    // 充电操作
    chargingOperation: {
        status1: "idle",
        status2: "gun inserted",
        status3: "start charging",
        status4: "charging",
        status5: "undrawn gun",
        tab1: "Charging report data",
        tab2: "BMS reporting data",
        tab3: "Charging report data",
        startCharging: "start charging",
        msgType1: "real time",
        msgType2: "history",
        time: "Communication time",
        loadMore: "load more",
    },
    // 运维数据
    operData: {
        tab1: "device login",
        tab2: "device heartbeat",
        tab3: "fault report",
        tab4: "upgrade",
        upgrade: "upgrade",
        202: "Upgrade package version",
        1009: "maximum charging power",
        1007: "Maximum charging current",
        513: "SIM card ICCID",
        1003: "Disable/Allow offline charging",
        2024: "SIM card signal strength",
        100: "Networking",
        1010: "QR code",
        58: "Multi-rate unit price version number",
        sendSuccess: "The command has been sent, check the device status",
        allow: "allow",
        prohibit: "prohibit",
        ethernet: "ethernet",
        host: "host ip address",
        port: "host port",
        userName: "FTP username",
        password: "FTP user password",
        fileDir: "File Directory",
        success: "update successed",
    },
    // 短信管理
    messageManage: {
        msgTitle: "SMS pool",
        rechange: "rechange",
        remaining: "Remaining available number(s)",
        used: "Number of used bars (bars)",
        top5: "Remaining available top5",
        unit: "strip",
        remainingMin: "Remaining min",
        remainingMax: "Remaining max",
        usedMin: "min used",
        usedMax: "max used",
        recordBtn: "SMS record",
        rechargeBtn: "SMS recharge",
        totalNum: "Purchased",
        sentNum: "Used bars",
        addNum: "Add SMS",
        remainNum: "remaining messages",
        comboPkId: "buy SMS",
        paymentAmount: "Payment amount",
        msgRechange: "SMS recharge",
        comboPkIdPl: "Please select the number of SMS",
    },
    // 短信记录
    messageRecord: {
        tab1: "Purchase record",
        tab2: "send record",
        pkid: "order number",
        purchasedWay: "Ways to purchase",
        auditStatus: "Order Status",
        attachmentUrl: "appendix",
        downloadAttachmentUrl: "Download",
        audit: "audit",
        createUserName: "operator",
        purchasedCount: "Purchase Quantity",
        paymentAmount: "Payment amount",
        createTime: "purchase time",
        phoneNo: "phone",
        agent: "send type",
        bussType: "business type",
        pilot: "pilot",
        aliCloud: "ali Cloud",
        sendTime: "send time",
        content: "Send Content",
        status: "send status",
        auditAction: "Approval Status",
        oprSystemLogoFilePath: "Upload Attachment",
        msgAudit: "SMS audit",
        auditActionPl: "Please select a review status",
        oprSystemLogoFilePathPl: "Please upload attachment",
        auditAction1: "pass",
        auditAction2: "refuse",
        payMethod: "Payment method",
        invoiceStatus: "Invoicing status",
        contractAudit: "Contract Review",
        payAudit: "Payment review",
        invoiceAudit: "Invoice review",
        invoicing: "Invoicing",
        needContract: "Contract required",
        contractYes: "Yes",
        contractNo: "No",
        orderInfo: "Ordering Information",
        packageInfo: "Package Information",
        auditInfo: "Audit Information",
        auditComment: "Audit comments",
        auditYes: "Approved",
        auditNo: "Audit failed",
        remarkPl: "Please input audit opinion",
        orderStatus: "Status",
        orderAmount: "Amount",
        packagePrice: "Package Price",
        remark: "remark",
        invoiceInfo: "Invoice Information",
        auditRecord: "Audit records",
        payTime: "Pay time",
        contractNetFileUrl: "PURCHASE CONTRACT",
        paymentNetFileUrl: "Payment voucher",
        rechargeTime: "Recharge time",
        beforeSmsCount: "SMS before recharge",
        afterSmsCount: "SMS after recharge",
        contractStatus: "contract status",
        paymentStatus: "payment status",
        paymentVoucherStatus: "Payment review status",
    },
    // 短信定价
    messagePrice: {
        number: "Number of SMS",
        price: "Package price",
        contactPhone: "Contact phone number",
        status: "state",
        rechargeContact: "top-up contact",
        rechargeTips: "Modifying the contact information will synchronously modify the contact information of other SMS packages, please modify with caution",
        qrCodeFilePkId: "Contact WeChat",
        qrCodeFilePkIdTips: "Upload QR code, support .jpg .jpeg .png",
        qrCodeFilePkIdPl: "Please upload contact WeChat",
        updata: "Modify pricing",
        add: "Add pricing",
        close: "closure",
        closeConfirm: "Are you sure about closing?",
    },
    // license管理
    cardClient: {
        projectName: "project name",
        updataTime: "update time",
        queryCode: "View customer code",
        licenseBtn: "License management",
        createUserName: "founder",
        activatedAmount: "number of activated",
        projectCode: "Customer code",
        modifyTime: "Download license file",
        moduleNames: "Licence module",
        machineCode: "serial number",
        pileNumber: "Number of piles",
        status: "status",
        beginTime: "effective date",
        endTime: "Expire date",
        add: "Add item",
        projectNamePl: "Please enter a project name",
        projectCodeMax: "Client code must be 8 digits",
        modulePkIdsPl: "Please select Licence module",
        machineCodePl: "Please enter serial number",
        beginTimePl: "Please select an effective date",
        endTimePl: "Please select an expiration date",
        addLicence: "Add Licence",
        updataLicence: "Updata Licence",
        timeMax: "Effective date cannot exceed expiration date",
    },
    // SIM卡管理
    simOutTest: {
        projectName: "project name",
        keywords: "keywords",
        pileNoOrIccidPl: "device ID/ICCID",
        applicantOrCaller: "claimant/caller",
        simStatus: "SIM card status",
        createTime: "creation time",
        recallTest: "SIM card test",
        claim: "SIM card application",
        batchSync: "Batch sync",
        sync: "Synchronize",
        applicant: "claimant",
        caller: "call tester",
        outgoer: "Seller",
        modifyTime: "update time",
        simStatusPl: "Please select SIM card status",
        serialNumber: "device ID",
        applyTitle: "Apply for a SIM card",
        iccid: "SIM card number",
        iccidTips: "Please enter, limit 100 characters",
        importFile: "Importing files",
        downloadTpl: "Download template",
        simSum: "Number of SIM cards",
        applicantPl: "Please enter the claimant",
        iccidPl: "Please enter SIM card number",
        outgoerPl: "Please enter the sender",
        snStartNo: "Enter start number",
        snEndNo: "Enter end number",
        match: "match",
        projectNamePkId: "Associated project",
        saveExport: "save and export",
        modalTitle: "SIM card test",
    },
    // 生产任务单
    productionOrder: {
        step0: "process starts",
        step1: "first step",
        step2: "second step",
        step3: "third step",
        step4: "Process ends",
        content0: "Add task list",
        content1: "start production",
        content2: "Equipment storage",
        content3: "Quality inspection",
        content4: "Equipment delivery",
        keyword: "keywords",
        numOrProject: "Contract number/project name",
        modelName: "Device model",
        productionStatus: "Manufacturing state",
        createTime: "Date created",
        syncDev: "sync device",
        start: "start production",
        void: "void",
        changePriority: "Adjust priority",
        warehousing: "Equipment storage",
        check: "quality check",
        ship: "Equipment delivery",
        index: "serial number",
        priority: "priority",
        orderType: "Task order type",
        contractBillNumber: "contract number",
        projectName: "project name",
        platformModel: "Platform model",
        pileNum: "Equipment Quantity",
        doneModelNum: "Shipped",
        warehousingConfirm: "Are you sure you want to stock up??",
        delConfirm: "Are you sure you want to delete this production order?",
        voidConfirm: "Are you sure you want to void the production order??",
        startConfirm: "Are you sure you want to start production??",
        //新增
        projectInfo: "Project information",
        contractBillNumberPl: "Please select the contract number",
        priorityPl: "Please select a priority",
        projectNamePl: "Please select a project name",
        devInfo: "Device Information",
        materialNumber: "Material code",
        materialNumberPl: "Please enter the finished product code",
        clientNum: "Customer code",
        clientNumPl: "Please enter customer code",
        deviceModelPkId: "Device model",
        deviceModelPkIdPl: "Please select device model",
        platformModelPl: "Please select a platform model",
        deviceNo: "device ID",
        deviceStartNo: "start device number",
        deviceEndNo: "end device number",
        quantity: "Equipment Quantity",
        motherboard: "motherboard",
        motherboardPl: "Please enter the motherboard",
        interfaceBoard: "Interface version",
        interfaceBoardPl: "Please enter the interface version",
        displayScreen: "display",
        displayScreenPl: "Please enter the display",
        requirements: "Customization and Production Requirements",
        requirementsPl: "Please enter custom and production requirements",
        inputMaxPl: "Please enter, limit 100 characters",
        equipmentRemarks: "Equipment Notes",
        equipmentRemarksPl: "Please enter device remarks",
        adds: "Keep adding",
        issuerAndCard: "Card issuer + IC card",
        issuerAndCardPl: "Please enter the card issuer + IC card",
        remark: "Task list remarks",
        remarkPl: "Please enter a task note",
        verificationInfo: "Inspection information",
        verifier: "inspector",
        checkContent: "Check content",
        shippingInfo: "Shipping Information",
        deliveryRequirements: "Shipping requirements",
        logisticsAndNumber: "Logistics and tracking number",
        inspectionAndSignature: "Inspection and shipment inspection signature",
        shippingCardIssuerICCard: "Card issuer + IC card",
        shippingCardIssuerICCardPl: "Please enter the card issuer + IC card",
        orderTypePl: "Please select a task order type",
        add: "Add task list",
        updata: "Modify task list",
        details: "Task Order Details",
        other: "other information",
        deliveryRequirementsPl: "Please enter shipping request",
        logisticsAndNumberPl: "Please enter the logistics and tracking number",
        inspectionAndSignaturePl: "Please enter the signature for inspection and shipment inspection",
        verifierPl: "Please enter the verifier",
        checkContentPl: "Please enter the verification content",
    },
    //销售订单
    salesOrder: {
        globalSearch: "Contract number / project name / salesperson",
        sellerName: "Seller",
        specificationModel: "Specifications",
        month: "Estimated delivery",
        monthPl: "Please select estimated delivery",
        deliveryTime: "delivery time",
        shipConfirm: "Are you sure you want to ship?",
        childTitle: "Sub-items - Product Information",
        number: "quantity",
        requirementDesc: "Description of Requirement",
        requirementDescPl: "Please enter a requirement description",
        shippingAddress: "delivery address",
        shippingAddressPl: "Please enter shipping address",
        add: "Add sales order",
        contractBillNumberPl: "Please enter the contract number",
        specificationDetails: "specification",
        specificationDetailsPl: "Please enter the specification",
        sellerNamePl: "Please enter salesperson",
        month1: "January",
        month2: "February",
        month3: "March",
        month4: "April",
        month5: "May",
        month6: "June",
        month7: "July",
        month8: "August",
        month9: "September",
        month10: "October",
        month11: "November",
        month12: "December",
    },
    // 头部
    header: {
        clickGo: "Click to jump",
        out: "sign out",
        outConfirm: "Are you sure you want to log out?",
        unit: "",
    },
    // 设备档案
    reportFile: {
        pageTitle: "Report file",
        deviceArchivePkId: "File ID",
        deviceTypeName: "Equipment type",
        manufacturerName: "Manufacturer",
        deviceModelName: "Equipment model",
        deviceModelRatedPower: "Rated power",
        deviceModelChargeStandardName: "Equipment standards",
        archiveCode: "Report No",
        feelerMechanismName: "Testing agency",
        archiveCreateDate: "Report generation date",
        attachmentRecordPkId: "Type test report",
        entryDate: "Entry date",
        deviceRatedPower: "Power range(kW)",
        query: "Click to view",
        change: "Change report",
        updataTitle: "Please select a file",
        minDeviceRatedPowerError: "The minimum value of power range cannot be less than 0",
        maxDeviceRatedPowerError: "The maximum value of power range cannot be less than 0",
        minMaxDeviceRatedPowerError: "The maximum value of power range cannot be less than the minimum value",
    },
    // 站点规模配置
    siteSizeConfig: {
        smallSizeStaNum: "small-scale",
        mediumSizeStaNum: "Medium scale",
        largeSizeStatNum: "large-scale",
        configName: "Configuration Name",
        pileNum: "Number of piles (set)",
        power: "Power (kw)",
        min: "less than",
        max: "greater than",
        updataTitle: "Modify site size configuration",
        maxTips: "The maximum value cannot be less than:",
        maxPile: "Maximum value of pile",
        minPile: "Minimum value of pile",
        maxPower: "Maximum power",
        minPower: "Minimum power",
    },
    //站点开放管理
    bindSites: {
        rateSet: "Site rate setting",
        dcElecFee: "DC pile price",
        acElecFee: "AC pile price",
        dcServiceFee: "DC pile service fee",
        acServiceFee: "AC pile service fee",
        hasOriginalFee: "original price",
        yes: "Yes",
        beginTime: "Start time",
        endTime: "End time",
        bindSite: "Associated sites",
        self: "self-support",
        unself: "Non proprietary",
        amount: "amount of money",
        please: "Please input",
        pleaseCorrect: "Please enter the correct",
        towNumber: ", with a maximum of two decimal places",
        max: "Cannot be greater than",
        delayFeeTypePl: "Please choose the preferential way of delay fee",
        serviceFeeTypePl: "Please choose the service fee discount metho",
        elecFeeTypePl: "Please choose the preferential way of electricity charge",
    },
    // 共用名称（订单列表也在里面）
    commonTableName: {
        no: "No",
        yes: "Yes",
        open: "open",
        close: "close",
        insideOrderNo: "Internal order ",
        externalOrderNo: "External order",
        orderStatus: "Order status",
        orderType: "Order type",
        details: "details",
        endOrder: "Close order",
        error: "exception handling",
        orderNo: "order number",
        merchantName: "Merchant name",
        netSystemName: "Internet operators",
        staName: "Charging station",
        pileName: "Pile name",
        gunName: "Gun name",
        serialNumber: "Serial number",
        memberName: "Member name",
        phoneNo: "phone",
        carNo: "license plate",
        chargeBeginTime: "Start charging time",
        chargeEndTime: "End charging time",
        payTime: "Payment time",
        chargeDuration: "Charging time",
        delayDuration: "Time of pile occupation",
        chargeElect: "Quantity of electricity(kWh)",
        chargeAmount: "electricity fees(yuan)",
        serviceAmount: "Service fees",
        delayAmount: "Delay fee",
        totalAmount: "Total amount(yuan)",
        discountAmount: "Total discount amount",
        transactionAmount: "transaction Amount",
        startSoc: "start soc",
        endSoc: "end soc",
        stopReason: "stop reasonDesc",
        orderSource: "Order source",
        abnormalType: "abnormal type",
        elecPrice: "Electricity rete(yuan/kWh)",
        servicePrice: "Servic rate(yuan/kWh)",
        slotFlag: "Electricity fee type",
        slotElecPrice: "Electricity price(yuan)",
        time: "Time",
        delayMins: "Time(minute)",
        delayFreeMins: "Free time(minute)",
        sex: "Sex",
        vipLevel: "Member level",
        vipType: "Member type",
        vin: "VIN",
        cardType: "Car model",
        staType: "Site type",
        staStatus: "Site status",
        staAddr: "Site address",
        gunPkId: "gun id",
        manufacturer: "Belong to manufacturer",
        deviceType: "Pile type",
        devicemodel: "Equipment model",
        ratedPower: "Rated power",
        ratedCurrent: "Rated current",
        ratedVoltage: "Rated voltage",
        timeInterval: "time interval",
        chargeDiscount: "Electricity discount",
        serviceDiscount: "Dervice discount",
        delayDiscount: "Delay discount",
        totalDiscount: "Total discount amount",
        chargeTransAmount: "Paid in tariff",
        serviceTransAmount: "Paid in service fee",
        jian: "sharp",
        feng: "peak",
        ping: "flat",
        gu: "valley",
        beforeBalance: "Amount before(yuan)",
        afterBalance: "Amount after(yuan)",
        reteInfo: "Rate information",
        charge: "Charging times(second)",
        startTime: "Start time",
        endTime: "End time",
        modifyTime: "Modify time",
        staPkId: "Site number",
        entUserName: "Member companies",
        chargingCard: "User card number",
        consumptionPattern: "Charging mode",
        chargingMode: "charging mode",
        userType: "user type",
    },
    //账户充值
    accountRecharge: {
        auditMoney: "Recharge amount under review ",
        accountMaxTips: "Account balance up to ",
        rechargeMaxTips: "The maximum amount of a single recharge cannot exceed",
        rechargeAmount: "Recharge amount",
        accountMaxError: "The current account balance and the total amount to be reviewed have exceeded the maximum limit, and cannot be recharged temporarily",
        rechargeMax: "Currently, you can recharge up to ",
        rechargeSuccessTips: "Please wait for the review. Once the recharge amount is approved, it will be credited immediately",
        rechargeSuccess: "Recharge completed",
    },
    //账户充值-- 资金记录
    accountRechargeRecord: {
        transactionTime: "Recharge time",
        rechargeAmount: "Recharge amount",
        beforeBalance: "Balance before recharge",
        afterBalance: "Balance after recharge",
    },
    //账户退款-- 资金记录退款
    accountRefundRecord: {
        transactionTime: "Time to apply for refund",
        refundAmount: "Refund amount",
        refundedAmount: "Successful refund balance",
        orderStatusDesc: "Order status",
        transactionAmount: "Total amount of refund",
        wxTransAmount: "WeChat refund amount",
        alipayTransAmount: "Alipay refund amount",
        cashTransAmount: "Cash refund amount",
        accountBalance: "Current total balance",
        refundMethod: "Refund channel",
        exportName: "Refund record",
    },
    // 城市操作页面
    cityConfig: {
        name: "area name",
        regionLevel: "level",
        regionLevel1: "Province",
        regionLevel2: "City",
        regionLevel3: "Area",
        mergerName: "full name",
        pinyin: "Regional Pinyin",
        cityCode: "City Code",
        shortName: "code",
        zipCode: "zip code",
        pkid: "regionalism code",
        lng: "longitude",
        lat: "Dimension",
        lngLat: "Meridian dimension",
        addRow: "add",
        modalTitle: "Provincial and urban modifications",
        pkidPl: "Please enter the administrative division code",
        namePl: "Please enter a name",
        pinyinPl: "Please input regional pinyin",
        lngPl: "Please enter the longitude dimension",
        lngMax: "The dimension value cannot be greater than 1000",
        lngLenMax: "Decimals in the longitude dimension cannot be greater than 6 digits",
    },
    modalShowMap: {
        showMap: "Open map",
        addrPl: "Please enter the address",
        noData: "no data",
    },
    //发票管理
    invoiceInfo: {
        applicationTime: "Application time",
        globalSearch: "Order number/Phone number",
        invoiceType: "Invoice type",
        invoicingStatus: "Invoicing status",
        auditSettings: "Audit settings",
        invoiceOrderNumber: "Invoice order number",
        invoiceHeaderType: "Invoice title type",
        invoiceTitle: "Invoice title",
        taxNumber: "Tax number",
        invoiceAmount: "Invoice amount(RMB)",
        phoneNumber: "Phone number",
        invoicing: "Invoicing",
        invoiceUserName: "Invoicing User",
        issuer: "Issuer",
        processingMethod: "Processing method",
        courierCompany: "Courier company",
        shipmentNumber: "Shipment number",
        remark: "Remark",
        haveBeenMailed: "mail",
        noNeedToMail: "No need to mail",
        enterIssuer: "Please enter the billing person",
        selectMethod: "Please select the billing method",
        validationError: "Form validation error",
        selectAddress: "Please enter the mailing address",
        enterNumber: "Please enter the mailing order number",
        orderNumberLength: "The length of the mailing order number must not be less than eight digits",
        invoiceSuccessful: "Invoice successful",
        numberOfInvoices: "Number of invoices",
        electronicInvoice: "Electronic invoice",
        paperInvoice: "Paper invoice",
        totalInvoicedAmount: "Total invoice amount",
        invoicedServiceFee: "Invoiced service fee",
        invoicedElectricityBill: "Electricity billed",
        invoiceReviewProcess: "Invoice review process",
        on: "Turn on",
        close: "Turn off",
        selectionProcess: "Please select the invoice review process",
        setSuccessfully: "Set successfully",
        invoiceInformation: "Invoice Information",
        serviceCharge: "Service fee(RMB)",
        electricityBill: "Electricity fee(RMB)",
        eMail: "EMail",
        receivingInformation: "Receiving information",
        invoicingInformation: "Invoicing information",
        processingTime: "Processing time",
        invoiceSerialNumber: "Invoice serial number",
        payee: "Payee",
        reviewer: "Reviewer",
        unit: "Unit",
        invoicePicture: "Invoice picture",
        shippingAddress: "Shipping Address",
        denialReason: "Please enter the reason for rejection",
        orderNumber: "Order number",
        delayFee: "Delay fee(RMB)",
        discountedPrice: "Discount amount(RMB)",
        amountActuallyPaid: "Actual payment amount(RMB)",
        reviewCompleted: "Review completed",
        invoiceOperator: "Invoice operator",
        invoiceOrder: "Invoice Order",
        invoiceAuditRecord: "Audit records",
        operationTime: "Operation time",
        operationStatus: "Operation action",
        operation: "Operator",
        applyStatuse: "current state",
        confirmAudit: "Are you sure to approve?",
        operationSys: "System automatic processing",
        registerAddress: "registered address",
        registerTelephone: "registered Phone",
        bankDeposit: "Bank of deposit",
        bankAccountNo: "bank account",
        requestInvoiceType: "application type",
        requestInvoiceTypeSelect1: "Charging invoice",
        requestInvoiceTypeSelect2: "SMS recharge invoice",
    },
    //短信配置
    messageConfig: {
        tab1: "Contract configuration",
        tab2: "Payment method",
        tab3: "Margin reminder",
        tab4: "Registration Configuration",
        contractConfig: "Contract configuration",
        needContract: "Contract required",
        attachmentPkId: "Purchase Contract Template",
        attachmentPkIdPl: "Please upload the file",
        transfer: "Corporate transfer",
        bankAccountName: "Account name",
        bankDeposit: "bank of deposit",
        bankAccountNo: "bank account",
        wxPay: "WeChat Pay",
        appId: "Official account appid",
        mchId: "Merchant ID",
        mchName: "MERCHANT NAME",
        mchKey: "Merchant Key",
        notifyUrl: "Asynchronous notification interface",
        bankAccountNamePl: "Please enter the name of the receiving account",
        bankAccountNoPl: "Please enter the receiving bank account",
        bankDepositPl: "Please enter the account opening bank",
        appIdPl: "Please enter appId",
        mchIdPl: "Please enter the WeChat merchant account",
        mchKeyPl: "Please enter the WeChat merchant key",
        mchNamePl: "Please enter the merchant name",
        notifyUrlPl: "Please enter the asynchronous notification interface",
        reminder: "Margin reminder",
        onOff: "Is it enabled",
        smsReminderValue: "Reminder threshold",
        smsReminderValueMinTips: "Send notification when there are less than",
        smsReminderValueMinTips2: "remaining SMS messages",
        configRegister: "Register as a SMS sending operator",
        operPl: "Please select an operator",
    },
    // 短信发票
    msgApplyInvoice: {
        hasDefault: "default",
        setHasDefault: "set as default",
        ent: "Enterprise unit",
        entNo: "Individual/Non Corporate",
        info: "Receiving information",
        sendEmail: "E-mail",
        phoneNo: "phone",
        addressee: "recipient",
        mailingAddress: "Shipping address",
        sublimt: "Submit application",
        addresseePl: "Please enter the recipient",
        mailingAddressPl: "Please enter the shipping address",
        invoiceTitleInfo: "Invoice header information",
        invoiceTitleType: "Invoice Type",
        invoiceTitle: "Title Name",
        taxId: "duty paragraph",
        registerTelephone: "Registration Phone",
        registerAddress: "Company Registered Address",
        hasDefaultSelect: "Default or not",
        invoiceAccount: "Invoicing amount",
        applyStatus: "Invoicing status",
        invoiceYes: "Agree",
        invoiceNo: "Refuse",
        invoiceRemark: "Reject Reason",
        invoiceRemarkPl: "Please enter the reason for rejection",
    },
    // 服务商配置
    serviceProvider: {
        tab1: "WeChat official account",
        tab2: "WeChat mini program",
        tab3: "Service Provider Information",
    },
    // 导入模板
    importModal: {
        importTemplate: "Import Template",
        downloadTemplate: "Download Template",
        selectFile: "choose file",
    },
    //SIM卡管理
    simManage: {
        allTestBtn: "Batch testing",
        testBtn: "testing",
        allChangeBtn: "Batch changes",
        changeBtn: "changes",
        allRenewBtn: "Batch renewal",
        renewBtn: "renewal",
        changeRecord: "Change record",
        renewalRecord: "Renewal Record",
        staNum: "Total number of sites",
        pileNum: "Total number of devices",
        successNum: "Successfully tested",
        toBeActivatedNum: "To be activated",
        activatedNum: "Active",
        closedNum: "shutdown",
        testableNum: "testable",
        inventoryNum: "inventory",
        closeSoonNum: "Pre closing account",
        dueSoonNum: "due",
        preCloseNum: "About to close account",
        testBtnConfirm: "Determine to conduct testing on the operator",
        allTestBtnConfirm: "Confirm to conduct testing on selected operators",
        allTestBtnConfirmTips: "Due to the large number of devices, the testing time may be too long. Please review the testing results later",
        successNumSta: "SIM card successfully tested",
        dueSoonNumSta: "SIM cards that are about to expire",
        closeSoonNumSta: "SIM card about to be closed",
        noCallNum: "Not recalled",
        importNum: "import",
        matchNum: "mate",
        use4gNum: "4g",
        networkNum: "Ethernet",
        wifiNum: "WiFi",
        unknownNum: "unknown",
        callNum: "Recalled",
        other: "other",
        changType: "Change operation",
        changType1: "Duplicate machine",
        changType0: "shutdown",
        stopReason: "Reason for shutdown",
        stopReasonPl: "Please enter the reason for the shutdown, which should not exceed 50 characters",
        stopReasonPlRule: "Please enter the reason for the shutdown",
        iccidTitle: "Confirm to make changes to the selected SIM card",
        iccidTitleAll: "Batch change: Confirm to make batch changes to the selected SIM card",
        oprTitle: "Confirm changes to the selected operator",
        oprTitleAll: "Batch change: Confirm to make batch changes to the selected operator",
        renewalDate: "Renewal date",
        endDateType: "Deadline",
        endDateType0: "Fixed date",
        endDateType1: "Renewal extension time",
        endDateTypePl: "Please select a deadline",
        renewalTimePl: "Please select a date",
        renewIccidTitle: "Confirm to renew the selected SIM card",
        renewIccidTitleAll: "Batch renewal: Confirm the batch renewal of the selected SIM card",
        renewOprTitle: "Confirm renewal of selected operators",
        renewOprTitleAll: "Batch renewal: Confirm batch renewal for selected operators",
        renewalDateMaxError: "The renewal date cannot be greater than the deadline",
    },
    // SIM卡管理
    systemSim: {
        status: "SIM card status",
        activeDate: "activation date",
        endDate: "deadline",
        renewalDate: "Renewal date",
        closingDate: "Closing date",
        hasBindOpr: "Associated Operators",
        hasRemark: "Comment Status",
        changeAllOpenBtn: "Batch replication",
        changeAllStopBtn: "Batch shutdown",
        changeOpenBtn: "Replication",
        changeStopBtn: "Shutdown",
        remarkAllBtn: "Batch remarks",
        remarkBtn: "remarks",
        testBtnConfirm: "Confirm calling for testing of the SIM card",
        allTestBtnConfirm: "Confirm to test the selected SIM card",
        stopReason: "Reason for shutdown",
        networkingMode: "Networking methods",
        dataFrom: "access",
        remarkOperate: "remark operation",
        remarkPl: "Please enter remark information",
        remarkOpen: "Enable remarks",
        remarkColse: "Close remarks",
        allRemark: "Batch remarks",
        remarkNum: "remarks",
        totalNum: "Total SIM card",
    },
    // 变更日期
    simChangeRecord: {
        changeDate: "Change date",
        stopReason: "Reason for shutdown",
        stopReasonRemark: "Shutdown remarks",
        operateState: "Operational state",
        failReason: "failure reason",
        createUserName: "Changed by",
        createUserId: "operator",
    },
    // 电池检测
    batteryTest: {
        orderNo: "Charging order number",
        acquired: "User Status",
        userName: "User Name",
        userPhone: "User phone",
        detailsBtn: "Report Details",
        acquiredStatus: "User Status",
        carBatteryInfo: "Vehicle and charging information",
        carInfo: "Vehicle information",
        chargeInfo: "Charging information",
        carNo: "License plate number",
        libMaf: "Battery manufacturer",
        brand: "Vehicle brand",
        libType: "Type",
        model: "Model",
        libBday: "Battery production date",
        stdQ: "Rated capacity of the vehicle",
        stdV: "Rated total voltage of the vehicle",
        chaE: "Current charging amount",
        startTime: "Charging start time",
        chaTime: "Duration of this charging",
        endTime: "Charging end time",
        dsoc: "SOC growth",
        carbon: "Saving carbon emissions this time",
        batteryAnalysis: "Battery Health Analysis",
        socSta: "SOC status",
        trateMax: "Maximum temperature rise rate",
        cellVSta: "Individual voltage status",
        tempAve: "Average charging temperature",
        tsta: "Temperature state",
        socStart: "Starting SOC this time",
        rsta: "Insulation state",
        socEnd: "End of this SOC",
        conSta: "Power link status",
        powerAve: "Average power",
        healthScore: "Health score",
        score: "",
    },
    siteTag: {
        tagName: "tag name",
        boundStaNum: "Associated Sites",
        createTime: "Creation time",
        bindSite: "Associated Sites",
        addTag: "Add labels",
    },
    //服务商信息
    operInfo: {
        feedbackFunction: "Feedback function enabled",
        operName: "Service providers",
        contactPerson: "contacts",
        contactPhone: "Contact phone number",
        action: "operation",
        config: "allocation",
        contactWechat: "Contact person WeChat",
        operInfoConfig: "Service Provider Information Configuration",
        contactWechatCode: "Contact person's WeChat QR code",
        upload: "upload",
        confirm: "confirm",
        cancle: "cancel",
        operNamePl: "Please enter the name of the service provider",
        contactPersonPl: "Please enter the contact person's name",
        contactPhonePl: "Please enter the contact phone number",
        cannotOpen: "Unable to open",
        openTip1: "Unable to enable this function temporarily",
        openTip2: "Service provider information needs to be configured first",
        qrCode: "QR code",
        problemType: "Problem type",
        operHasRead: "Has read it",
        operHasReply: "Does respond",
        addFeedback: "Add feedback",
        feedbackTime: "Feedback time",
        feedbackPerson: "Feedback person",
        problemContent: "Problem content",
        replyTime: "Reply time",
        addProblem: "New questions added",
        checkReply: "View replies",
        operReply: "Service Provider Response",
        replyContent: "Reply content",
        yes: "Yes",
        no: "No",
        replyPerson: "Respondent",
        replyFeedback: "Reply to feedback",
        operatorReply: "Service Provider Response",
        checkFeedback: "View feedback",
        replySuccess: "The reply was successful",
    },
};
